import React, { useEffect, useRef, useState } from "react";
import { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Box, Typography, useMediaQuery } from "@mui/material";
import CalendarIcon from "../../../Custom-imeges/Workflows-Icons/CalendarIcon";
interface WorkflowFilterProps {
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  handleClose: () => void;
  method: (fromDate: Dayjs | null, toDate: Dayjs | null) => void;
  handleDateChange: (date: Dayjs | null, isFrom: boolean) => void;
  handleResetFilter:()=>void;
}
const WorkflowFilter = ({
  fromDate,
  toDate,
  handleClose,
  method,
  handleDateChange,
  handleResetFilter
}: WorkflowFilterProps) => {
  const isMobile = useMediaQuery("(max-width: 1150px)");
  const [openCalFromDate,setOpenCalFromDate]=useState(false)
  const [openCalToDate,setOpenCalToDate]=useState(false)
  const toDateRef = useRef<HTMLDivElement>(null);
  useEffect(()=>{
    setOpenCalFromDate(false);
    setOpenCalToDate(false)
  },[isMobile])
  useEffect(()=>{
    setOpenCalFromDate(false)
    setOpenCalToDate(true)
    if (toDateRef.current) {
      toDateRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  },[fromDate])
  useEffect(()=>{
    setOpenCalToDate(false)
  },[toDate])
  const toggleFromDate=()=>{
    if(isMobile){
      if(openCalToDate){
        setOpenCalToDate(false)
        setOpenCalFromDate(true)
      }
      else{
        setOpenCalFromDate(!openCalFromDate)
      }
    }
  }
  const toggleToDate=()=>{
    if(isMobile){
      if(openCalFromDate){
        setOpenCalFromDate(false)
        setOpenCalToDate(true)
      }
      else{
        setOpenCalToDate(!openCalToDate)
      }
    }
  }
  return (
    <Box
      sx={{
        background: "var(--sub_background6)",
        display: "flex",
        flexDirection: "column",
        height: "441.989136px",
        borderRadius: "16px",
        border: " 1px solid var(--A_font-color72)",
        padding: "16px",
        gap: "16px",
        overflowY:"auto",
        scrollbarWidth:"none",
        justifyContent:isMobile? "space-between":""
      }}
    >
      <Box className="workflow-history-date-filter">
        <Box
          className="workflow-history-date-filter-from"
          sx={{
            height:!(isMobile&&!openCalFromDate)? "359.989136px":"100%",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "inline-block",
              width: "95%",
              marginBottom: "1rem",
            }}
          >
            {/* Label */}
            {fromDate && <Typography className="Label-date">From</Typography>}

            {/* Content Box */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "var(--m_font-color30)",
                padding: "12px 16px",
                borderRadius: "12px",
              }}
            >
              <Typography className="date-value">
                {fromDate ? fromDate.format("MM/DD/YYYY") : "From"}
              </Typography>
              <span onClick={toggleFromDate}>
              <CalendarIcon className="cal-icon" />
              </span>
            </Box>
          </Box>
          <Box className="workflow-history-date-filter-from-date" 
          sx={{
            display:isMobile&&!openCalFromDate?"none":"block"
          }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                className="workflow-date-calendar"
                value={fromDate}
                onChange={(date) => handleDateChange(date, true)}
              />
            </LocalizationProvider>
          </Box>
        </Box>
        <Box
          className="workflow-history-date-filter-from"
          ref={toDateRef}
          sx={{
            height:!(isMobile&&!openCalToDate)? "359.989136px":"100%",

          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "inline-block",
              width: "95%",
              marginBottom: "1rem",
            }}
          >
            {/* Label */}
            {toDate && <Typography className="Label-date">To</Typography>}

            {/* Content Box */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "var(--m_font-color30)",
                padding: "12px 16px",
                borderRadius: "12px",
              }}
            >
              <Typography className="date-value">
                {toDate ? toDate.format("MM/DD/YYYY") : "To"}
              </Typography>
              <span onClick={toggleToDate}>
              <CalendarIcon className="cal-icon" />
              </span>
            </Box>
          </Box>
          <Box className="workflow-history-date-filter-from-date"
           sx={{
            display:isMobile&&!openCalToDate?"none":"block"
          }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                className="workflow-date-calendar"
                value={toDate}
                onChange={(date) => handleDateChange(date, false)}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: "97%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            fontFamily: "Roboto",
            fontWeight: "500",
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0.5px",
            color: "#12B6EA",
            textDecoration: "underline",
            textUnderlineOffset: "4px" ,
            paddingLeft:"10px",
            cursor:"pointer"
          }}
          onClick={handleResetFilter}
        >
          Reset
        </Box>
        <div className="apply-buttons btns-create-workflow duplicate-workflow" style={{margin:"0px"}}>
          <button className="CancelDeletePersonaBtn" onClick={handleClose}>
            Cancel
          </button>
          <button
            className={`NextCreateWorkflow`}
            onClick={() => method(fromDate, toDate)}
            disabled={!fromDate && !toDate}
            style={{ opacity: (!fromDate && !toDate )? 0.5 : 1 }}
          >
            Save
          </button>
        </div>
      </Box>
    </Box>
  );
};

export default WorkflowFilter;
